const Payroll = '5f23607a-1b53-432e-ba01-b5b9399fad87'
const Accounting = '2d8d60e2-dcab-430d-add0-aa8bf1096f16'

export { Payroll, Accounting }
